import { omit } from 'lodash'
import { toJS } from 'mobx'
import dayjs, { Dayjs } from 'shared/dayjs'
import {
  getTimeZoneDateFromUTCDate,
  prepareEventForUpdate
} from './tabs/event-detail/eventDetailUtils'
import { ManageEventDetailDayjs } from './EventEditPage'
import { AttendanceFilter } from 'front-end/src/pages/manage-events/event-edit/types/AttendanceFilter'

export enum EventQueryAccessor {
  event = 'event',
  recurringEvent = 'recurringEvent'
}

export const prepareEventPayload = (
  payload: Partial<ManageEventDetailDayjs>
) => {
  const payloadWithUTC = prepareEventForUpdate(payload)
  return omit(toJS(payloadWithUTC), [
    'attendeesCount',
    'inviteesCount',
    'presentCount',
    'id',
    'tags',
    'attendance_type',
    'published_date',
    'update_email_sent_at',
    'facilitator',
    'author',
    'google_meet_id',
    'ms_teams_url',
    'recurring_event_id',
    'relatedCertifications',
    'recurringEvent',
    'recurrence',
    '__typename'
  ])
}

export const prepareRecurringEventPayload = (
  payload: Partial<ManageEventDetailDayjs>
) => {
  const payloadWithUTC = prepareEventForUpdate(payload)
  return omit(
    toJS({
      ...payloadWithUTC,
      // @ts-ignore
      recurrence: omit(payload.recurrence, ['__typename'])
    }),
    [
      'attendeesCount',
      'inviteesCount',
      'presentCount',
      'id',
      'tags',
      'published_date',
      'update_email_sent_at',
      'facilitator',
      'author',
      'google_meet_id',
      'ms_teams_url',
      'recurringEvent',
      'events',
      '__typename'
    ]
  )
}

// Backend stores dates in utc separate from timezone. So first of all we should
// create Dayjs instances in utc zone. With time and date grabbed from shifted date with timezone.
export const deserializeEventTimesForManage = (
  input: Partial<ManageEventDetailDayjs>
): Partial<Omit<ManageEventDetailDayjs, 'start_time' | 'end_time'>> & {
  start_time: Dayjs | null
  end_time: Dayjs | null
} => {
  if (!input.start_time && !input.end_time) {
    // because of types return like this
    return {
      ...input,
      start_time: null,
      end_time: null
    }
  }
  return {
    ...input,
    start_time: getTimeZoneDateFromUTCDate({
      date: input.start_time || dayjs().startOf('hour').toString(),
      timezone: input.timezone
    }),
    end_time: getTimeZoneDateFromUTCDate({
      date: input.end_time || dayjs().startOf('hour').add(1, 'hour').toString(),
      timezone: input.timezone
    })
  }
}

export const prepareFilters = (
  selectedStatus: AttendanceFilter,
  search: string
) => {
  const filters: any[] = []

  if (selectedStatus && selectedStatus?.filter) {
    filters.push(selectedStatus.filter)
  }
  if (search) {
    filters.push({
      value: search
    })
  }

  return filters
}
